import { SingleSelect } from "@/components/pieces/form/SingleSelect";
import { useWorkspaceGroupsQuery } from "@/graphql";
import { ensureNonNullArray } from "@/utils/array";

// TODO(bdj): Ideally this wouldn't make a query and the groups would be passed in as a prop

interface GroupSelectProps {
  groupId: string;
  onGroupIdChange: (value: string) => void;
}

export function GroupSelect({ groupId, onGroupIdChange }: GroupSelectProps) {
  const { data } = useWorkspaceGroupsQuery({
    fetchPolicy: "network-only",
    variables: {
      sortField: "name",
      sortDesc: true,
    },
  });
  const options = ensureNonNullArray(data?.workspaceGroups).map((group) => ({
    label: group.name,
    value: group.id,
  }));

  return (
    <SingleSelect
      options={options}
      value={groupId}
      onChange={onGroupIdChange}
      placeholderLabel="Select Group"
    />
  );
}
